const downloadAppSection = {
  card: {
    tag: 'Baixe já o nosso app',
    title: 'Simule de forma fácil e rápida',
    description:
      'Gerencie seu empréstimo online, a qualquer hora e em qualquer lugar. Basta baixar o nosso app: abra a câmera do seu celular e escaneie o código ao lado.',
    descriptionMobile:
      'Gerencie seu empréstimo online, a qualquer hora e em qualquer lugar. Basta baixar o nosso app.',
    href: ' https://www.creditas.com/baixar-app',
  },
};

export { downloadAppSection };
